export default __webpack_public_path__ + "static/media/headshot.25de78e3.jpg";